module.exports = __webpack_public_path__ + "static/media/OrdemServico2.8a8e3613.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancOrdemServicos/OrdemServico2.png
// module id = 1765
// module chunks = 0